import * as React from "react";
import * as ReactDOM from "react-dom";

import {combineClassNames} from "../../Utils/ReactUtils";


export class CompactDropdownControlProps {
    className?: string;
    contentClassName?: string;
    content?: JSX.Element | JSX.Element[];
    closeOnClick?: boolean;
}

export interface CompactDropdownControlState {
    open?: boolean;
    className?: string;
    contentClassName?: string;
}

export class CompactDropdownControl extends React.Component<CompactDropdownControlProps, CompactDropdownControlState> {
    familyId: string;

    constructor(props) {
        super(props);
        this.state = {
            className: props.className,
            contentClassName: props.contentClassName
        }
        this.familyId = Math.random().toString(24).substr(2, 12);
    }

    private documentClicked = (ev: MouseEvent) => {
        if (this.state.open) {
            if (ev.defaultPrevented)
                return;
            let clickIsInside = false;
            let clickedOnIcon = false;
            let target = ev.srcElement;
            while (target) {
                if (target.className.toString().indexOf(this.familyId) >= 0) {
                    clickIsInside = true;
                }
                if (target.className.toString().indexOf("compact-menu-icon") >= 0) {
                    clickedOnIcon = true;
                }
                target = target.parentElement;
            }
            if (!clickIsInside) {
                this.close();
            }
            else if (this.props.closeOnClick) {
                if (clickedOnIcon) {
                    ev.preventDefault();
                    ev.stopPropagation();
                }
                this.close();
            }
        }
    }

    private iconClicked = (ev: React.MouseEvent<any>) => {
        let element = ev.nativeEvent.srcElement || (ev.nativeEvent.target as Element);
        if (element.className.toString().indexOf(this.familyId) < 0)
            return;
        ev.preventDefault();
        ev.stopPropagation();
        this.setState({
            open: !this.state.open
        }, () => {
            this.toggleStatusBarDisplay(!this.state.open);
        });
    }

    componentDidMount() {
        window.addEventListener("click", this.documentClicked);
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.documentClicked);
    }

    public close() {
        this.setState({
            open: false
        }, () => {
            this.toggleStatusBarDisplay(true);
        });
    }

    /**
     * show or hide status bar if there
     * @param show
     */
    private toggleStatusBarDisplay(show: boolean) {
        $('#app-body > * > .status-bar').css({ display: show ? 'block' : 'none' });
    }

    render() {
        let open = (this.state.open) ? "open" : "";
        let visible = (this.state.open) ? "visible" : "";
        return (
            <div className={combineClassNames("compact-dropdown-menu", this.state.className)}>
                <button aria-haspopup="true" role="button" aria-controls="MainMenu" aria-label="Main Menu" className={combineClassNames("compact-menu-icon", open, this.familyId, "compact-menu-icon-btn")} onClick={(ev) => this.iconClicked(ev)}>
                    <div className={combineClassNames("compact-menu-content", this.state.contentClassName, visible)}>
                        {this.props.content}
                    </div>
                </button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/CompactDropdownControl.tsx